/*
 * Tinker Coffee: live "Subscribe & Save" price on product pages
 * ------------------------------------------------------------
 * Theme:   Flow (WeTheme)
 * Widget:  Recharge Subscription Widget v2 (app embed, Shopify Checkout Integration)
 *
 * What it does
 *   Recharge's widget does not update the theme's price label when a customer
 *   switches between one-time and subscription (a documented Recharge limitation).
 *   This script watches the product form and rewrites the price (#ProductPrice)
 *   from the variant's selling_plan_allocations, which Shopify already includes
 *   in the product JSON. When a subscription is selected it shows the discounted
 *   price with the regular price struck through; when one-time is selected it
 *   restores the regular price. It follows variant changes too.
 *
 * Install (do this on a DUPLICATE of the live theme first)
 *   1. Online Store > Themes > (duplicate) > Edit code
 *   2. Assets > Add a new asset > upload this file as tinker-subscription-price.js
 *   3. Open layout/theme.liquid and add this line just above </body>:
 *        {{ 'tinker-subscription-price.js' | asset_url | script_tag }}
 *   4. Preview the theme, open any coffee product, toggle one-time / subscribe,
 *      change size and grind, confirm the price follows. Then publish.
 *
 * Remove: delete the line from theme.liquid (and the asset).
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 150;
  var timer = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function productJson(form) {
    var scope = form.closest('.shopify-section') || document;
    var el = scope.querySelector('script.product-json, script[id^="ProductJson"]')
          || document.querySelector('script.product-json, script[id^="ProductJson"]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  function readState() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var product = productJson(form);
    var idEl = form.querySelector('[name="id"]');
    if (!product || !idEl) return null;
    var variant = product.variants.filter(function (v) { return String(v.id) === String(idEl.value); })[0];
    if (!variant) return null;

    var planEl = form.querySelector('[name="selling_plan"]');
    var planId = planEl ? planEl.value : '';
    var subPrice = null;

    if (planId) {
      var alloc = (variant.selling_plan_allocations || []).filter(function (a) {
        return String(a.selling_plan_id) === String(planId);
      })[0];
      if (alloc) {
        subPrice = alloc.per_delivery_price != null ? alloc.per_delivery_price : alloc.price;
      } else {
        // Fallback (the Sightglass approach): read the price Recharge renders in its own widget.
        var w = document.querySelector('recharge-subscription-widget');
        var el = w && w.shadowRoot && w.shadowRoot.querySelector('.rc-price:not(.strike-through)');
        var m = el && el.textContent.match(/\d+(?:\.\d{2})?/);
        if (m) subPrice = Math.round(parseFloat(m[0]) * 100);
      }
    }
    return { variant: variant, planId: planId, subPrice: subPrice };
  }

  // Idempotent: only touches the DOM when something actually differs, so the
  // observers below cannot loop.
  function removeCompare(priceEl) {
    var compare = priceEl.parentNode.querySelector('.tc-sub-compare');
    if (compare) compare.parentNode.removeChild(compare);
  }

  function render() {
    var priceEl = document.querySelector('#ProductPrice');
    if (!priceEl) return;
    var s = readState();
    if (!s) { removeCompare(priceEl); return; } // never leave a stale struck price
    var moneyEl = priceEl.querySelector('.money') || priceEl;

    var isSub = !!(s.planId && s.subPrice != null && s.subPrice !== s.variant.price);
    var target = isSub ? s.subPrice : s.variant.price;

    if (moneyEl.textContent.trim() !== money(target)) moneyEl.textContent = money(target);
    var content = (target / 100).toFixed(2);
    if (priceEl.getAttribute('content') !== content) priceEl.setAttribute('content', content);

    // Flow's price group is flex row-reverse, so a node placed BEFORE #ProductPrice
    // in the DOM renders AFTER it visually: "$12.00  $16.00(struck)".
    var compare = priceEl.parentNode.querySelector('.tc-sub-compare');
    if (isSub) {
      if (!compare) {
        compare = document.createElement('s');
        compare.className = 'tc-sub-compare';
      }
      if (compare.nextSibling !== priceEl) priceEl.parentNode.insertBefore(compare, priceEl);
      if (compare.textContent !== money(s.variant.price)) compare.textContent = money(s.variant.price);
    } else if (compare) {
      removeCompare(priceEl);
    }
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(render, DEBOUNCE_MS);
  }

  function addStyles() {
    if (document.getElementById('tc-sub-price-style')) return;
    var st = document.createElement('style');
    st.id = 'tc-sub-price-style';
    st.textContent = '.tc-sub-compare{opacity:.5;margin-left:.45em;font-weight:400}';
    document.head.appendChild(st);
  }

  function init() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !document.querySelector('#ProductPrice')) return;
    addStyles();

    // 1. Widget clicks (composed "input" events bubble out of its shadow DOM),
    //    plus anything that changes inside the product form (size/grind swatches,
    //    the hidden variant select, quantity).
    ['change', 'input'].forEach(function (ev) {
      document.body.addEventListener(ev, function (e) {
        var t = e.target;
        if (!t) return;
        if (t.tagName === 'RECHARGE-SUBSCRIPTION-WIDGET' || t === form ||
            (t.closest && t.closest('form[action*="/cart/add"]'))) queue();
      }, true);
    });

    // 2. Recharge sets the hidden selling_plan input's value attribute directly.
    new MutationObserver(queue).observe(form, {
      attributes: true, attributeFilter: ['value'], subtree: true, childList: true
    });

    // 3. Flow re-renders the price group on variant change; re-apply afterwards.
    var group = document.querySelector('.product-price-group');
    if (group) new MutationObserver(queue).observe(group, { childList: true, subtree: true, characterData: true });

    // 4. Custom events some themes/apps fire.
    document.addEventListener('variant:change', queue);
    document.addEventListener('subscription:option:changed', queue);

    render();
    setTimeout(render, 800); // widget finishes loading after DOMContentLoaded
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();